(function () {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.cozy-loved--swiper').forEach(function (el) {
    if (el.classList.contains('swiper-initialized')) return;

    var scope = el.closest('.cozy-loved') || document;

    new Swiper(el, {
      wrapperClass: 'cozy-loved--swiper--wrapper',
      slideClass: 'cozy-loved--block',
      slidesPerView: 'auto',
      spaceBetween: 10,
      loop: false,
      navigation: {
        nextEl: Array.from(scope.querySelectorAll('.cozy-loved--next')),
        prevEl: Array.from(scope.querySelectorAll('.cozy-loved--prev')),
        disabledClass: 'disabled',
      },
      breakpoints: {
        1024: {
          spaceBetween: 20,
        },
      },
    });
  });

  function equalizeTitles() {
    document.querySelectorAll('.cozy-loved--swiper--wrapper').forEach(function (wrapper) {
      var titles = wrapper.querySelectorAll('.cozy-loved--block--title');
      if (!titles.length) return;

      titles.forEach(function (title) {
        title.style.minHeight = '';
      });

      var maxHeight = 0;
      titles.forEach(function (title) {
        maxHeight = Math.max(maxHeight, title.offsetHeight);
      });

      titles.forEach(function (title) {
        title.style.minHeight = maxHeight + 'px';
      });
    });
  }

  equalizeTitles();

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(equalizeTitles);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equalizeTitles, 200);
  });
})();
